import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'objectPropertyLength',
  standalone: true,
})
export class ObjectPropertyLengthPipe implements PipeTransform {
  transform(value: any): number {
    return value ? Object.keys(value).length : 0;
  }
}
